import Vue from "vue";
import Vuex from "vuex";

import { mutations } from "./mutations";
import { getters } from "./getters";

import User from "./modules/user";
import AppEvent from "./modules/AppEvent";
import SystemSettings from "./modules/SystemSettings";
Vue.use(Vuex);

const state = {};

export default new Vuex.Store({
    state,
    mutations,
    getters,
    actions: {},
    modules: {
        User,
        AppEvent,
        SystemSettings
    }
});
